














































































/* tslint:disable:max-classes-per-file */
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {DeviceShadow, Project} from '@/types';
import WidgetService from '@/services/widget.service';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import ConnectivityService from '@/services/connectivity.service';

@Component
export default class Map extends Vue {
  @Action private changeProjectAsync: any;
  @Action private changeOrganisationAsync: any;
  @Action private addToastErrorMessage: any;

  @Getter private hasPermission!: any;
  @Getter private activeOrganisation: any;
  @Getter private organisations!: any;

  @Prop() private data!: any;
  @Prop({ default: () => ['devices'] }) private visibleMarkers!: string[];
  @Prop({ default: '70vh' }) private height!: string;
  @Prop({ default: true }) private showLegends!: boolean;

  private orgId: number | null = null;
  private projId: number | null = null;
  private hasTTISettings: boolean = false;

  private readonly DEFAULT_ZOOM = 15;

  private infoWindow: { [key: string]: HTMLElement } = {};
  private newDevicePopup: { [key: string]: DevicePopup } = {};
  private newGatewayPopup: { [key: string]: GatewayPopup } = {};
  private map: any;
  private deviceMarkers: { [key: string]: any} = {};
  private gatewayMarkers: { [key: string]: any} = {};
  private clusters: { [key: string]: any} = {};
  private markerList: google.maps.Marker[] = [];
  private deviceLocations: any[] = [];
  private gatewayLocations: any[] = [];
  private locations: any[] = [];
  private siteData: any[] = [];
  private visitedSiteList: any[] = [];
  private slide: { [key: string]: number } = {};
  private slideIndex: number = 0;
  private prev: any = {};
  private next: any = {};
  private current: number = 1;

  private async mounted() {
    await this.checkForLoraSettings();
    await this.$nextTick();
    await this.createMap();
  }


  @Watch('visibleMarkers')
  private toggleMarkers() {
    if (!this.visibleMarkers.includes('devices')) {
      for (const marker in this.deviceMarkers) {
        if (this.deviceMarkers[marker]) {
          this.deviceMarkers[marker].setVisible(false);
        }
      }
      this.clusters.repaint();
    } else {
      for (const marker in this.deviceMarkers) {
        if (this.deviceMarkers[marker]) {
          this.deviceMarkers[marker].setVisible(true);
        }
      }
      this.clusters.repaint();
    }
    if (!this.visibleMarkers.includes('gateways')) {
      for (const marker in this.gatewayMarkers) {
        if (this.gatewayMarkers[marker]) {
          this.gatewayMarkers[marker].setVisible(false);
        }
      }
    } else {
      for (const marker in this.gatewayMarkers) {
        if (this.gatewayMarkers[marker]) {
          this.gatewayMarkers[marker].setVisible(true);
        }
      }
    }
  }

  @Watch('$refs', {immediate: true, deep: true})
  private async createMap() {
    const mapStyle: any = [
      {
        featureType: 'poi',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'all',
        stylers: [
          {
            visibility: 'simplified',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
    ];
    if (this.$refs && this.$refs.expandedMap) {
      this.map = new google.maps.Map(this.$refs.expandedMap as any, {
        mapTypeControl: false,
        mapTypeId: 'mapStyle',
        fullscreenControl: false,
        streetViewControl: false,
      });
      this.map.mapTypes.set('mapStyle', new google.maps.StyledMapType(mapStyle, { name: 'Map Style' }));

      await this.setMapOptions();
      this.$emit('mapLoaded');
    }
  }

  private async loadDeviceLocations() {
    this.$emit('loadingLocations', true);
    try {
      const shadows = await WidgetService.getShadows();
      const devices = shadows.map((s: DeviceShadow) => {
        return {
          ...s.device,
          ...s.shadow,
        };
      });
      Vue.set(this, 'deviceLocations', devices);
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    } finally {
      this.$emit('loadingLocations', false);
    }
  }

  private async checkForLoraSettings(): Promise<void> {
    try {
      const hasTTISettings = await WidgetService.hasTTISettings();
      this.hasTTISettings = hasTTISettings.result;
      this.$emit('hasTTISettings', this.hasTTISettings);
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage(err.message);
    }

  }

  private async loadGatewayLocations() {
    this.$emit('loadingLocations', true);
    try {
      const gateways = await WidgetService.getGateways();
      Vue.set(this, 'gatewayLocations', gateways);
    } catch (e) {
      const err = e as Error;
    } finally {
      this.$emit('loadingLocations', false);
    }
  }
  private async setMapOptions() {
    for (const marker in this.deviceMarkers) {
      if (this.deviceMarkers[marker]) {
        this.deviceMarkers[marker].setMap(null);
        if (this.clusters) {
          this.clusters.removeMarker(this.deviceMarkers[marker]);
        }
       }
    }
    for (const marker in this.gatewayMarkers) {
      if (this.gatewayMarkers[marker]) {
        this.gatewayMarkers[marker].setMap(null);
       }
    }
    this.markerList = [];

    if (!this.orgId && !this.projId) {
      await this.loadDeviceLocations();
      if (this.hasTTISettings) {
        await this.loadGatewayLocations();
      }
    }

    this.locations = [...this.deviceLocations, ...this.gatewayLocations];

    const map = this.map;
    if (!this.locations.length) {
      map.setOptions({
        zoom: 3,
        center: { lat: 51.5072, lng: 0.1276 },
      });
      return;
    }
    const deviceGroups = this.deviceLocations.reduce((r, a) => {
      r[`${a.lat}${a.lng}`] = [...r[`${a.lat}${a.lng}`] || [], a];
      return r;
    }, {});

    this.deviceLocations.forEach((d: any) => d.count = deviceGroups[`${d.lat}${d.lng}`].length);
    for (const group in deviceGroups) {
      if (deviceGroups.hasOwnProperty(group)) {
        deviceGroups[group].forEach((field: any) => field.hasFaults = deviceGroups[group].some((f: any) => f.status === 'fault'));
      }
    }
    const gatewayGroups = this.gatewayLocations.reduce((r, a) => {
      r[`${a.lat}${a.lng}`] = [...r[`${a.lat}${a.lng}`] || [], a];
      return r;
    }, {});

    this.gatewayLocations.forEach((g: any) => g.count = gatewayGroups[`${g.lat}${g.lng}`].length);
    const latLngValues: google.maps.LatLng[] = this.locations.map((l) => new google.maps.LatLng(Number(l.lat), Number(l.lng)));
    if (this.locations.length) {
      this.generateDeviceMarkers(map, this.deviceLocations);
      this.generateGatewayMarkers(map, this.gatewayLocations);
      this.generateClusters(this.markerList);
      this.toggleMarkers();
    }

    if (latLngValues.length === 1) {
      map.setOptions({
        zoom: this.DEFAULT_ZOOM,
        center: latLngValues[0],
      });
    } else {
      const bounds = latLngValues.reduce((latlngBound, latlng) => {
        return latlngBound.extend(latlng);
      }, new google.maps.LatLngBounds());
      map.setOptions({
        zoom: 2, // Set min zoom in case fitBounds doesn't handle the zoom
        center: bounds.getCenter(),
      });

      map.fitBounds(bounds);
    }
  }

  private generateClusters(markers: any[]) {
    this.clusters = new MarkerClusterer(this.map, markers, {
      ignoreHidden: true,
      maxZoom: 10,
      styles: [
        {
          width: 30,
          height: 30,
          className: 'clustericon',
        },
        {
          width: 35,
          height: 35,
          className: 'clustericon',
        },
        {
          width: 40,
          height: 40,
          className: 'clustericon',
        },
      ],
      averageCenter: true,
      clusterClass: 'clustericon',
    });
  }

  private generateDeviceMarkers(map: google.maps.Map, locations: any) {
    const self = this;
    locations.forEach((location: {[key: string]: any}, locIndex: number) => {
      if (!location || !(location.lat && location.lng)) {
        return;
      }
      const spreadingFactor = location.network.loraSpreadingFactor ? location.network.loraSpreadingFactor : undefined;

      const marker = new google.maps.Marker({
        map,
        icon: location.status === 'fault' ? this.pinSymbol(this.getColor('fault')) : location.status === 'inactive' ? this.pinSymbol(this.getColor('inactive')) : this.pinSymbol(this.getColor('active', spreadingFactor)),
        title: location.name ? location.name : location.locationName,
        id: location.networkId,
        projectId: location.projectId,
        spreadingFactor: location.network.loraSpreadingFactor ? location.network.loraSpreadingFactor : null,
        position: {
          lat: Number(location.lat),
          lng: Number(location.lng),
        },
        location,
      } as any);
      this.deviceMarkers[(marker as any).id] = marker;
      this.markerList.push(marker);

      map.addListener('click', () => {
        for (const m in this.deviceMarkers) {
          if (this.deviceMarkers[m] && this.deviceMarkers[m].id) {
            if (this.newDevicePopup[this.deviceMarkers[m].id]) {
              this.newDevicePopup[this.deviceMarkers[m].id].setMap(null);
              delete this.newDevicePopup[this.deviceMarkers[m].id];
            }
          }
        }
      });

      let contentString =
          `<div id="${location.networkId}" class="text-body-2">`;
      contentString +=
          `<div class="row no-gutters d-flex justify-space-between flex-nowrap">
              <div id="col col-auto bodyContent">`;

      if (location.count > 1) {
        contentString += `
          <div class="slideshow-container">
        `;
        this.deviceLocations.forEach((loc, index) => {
          if (loc.lat === location.lat && loc.lng === location.lng) {
            this.slide[loc.networkId] = index;

            contentString += `<div class="slide" id="slide+${loc.networkId}"><p class="font-weight-bold mb-0">Device: ${loc.deviceName}</p>`;
            contentString += `<p class="mb-0">Project: ${loc.projectName}</p>`;
            if (loc.network && loc.network.station) {
              contentString += `<p class="mb-0">Gateway: ${loc.network.station}</p>`;
            }
            if (loc.network && loc.network.loraSpreadingFactor) {
              contentString += `
              <p class="mt-2 mb-0"> <i class="mr-2 mdi mdi-circle ${this.getIconColors('loraSpreadingFactor', loc.network.loraSpreadingFactor)}"></i>Spreading factor: ${loc.network.loraSpreadingFactor}</p>
            `;
            }
            if (loc.network && loc.network.snr) {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle ${this.getIconColors('snr', loc.network.snr)}"></i>SNR: ${loc.network.snr}</p>
              `;
            }
            if (loc.network && loc.network.rssi) {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle ${this.getIconColors('rssi', loc.network.rssi)}"></i>RSSI: ${loc.network.rssi}</p>
              `;
            }
            if (loc.status === 'fault') {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle error--text"></i>Status: Fault</p>
              `;
            }
            if (loc.status === 'active') {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle success--text"></i>Status: Active</p>
              `;
            }
            if (loc.status === 'inactive') {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle grey--text"></i>Status: Inactive</p>
              `;
            }
            contentString += `</div>`;
          }
        });
      } else {
        contentString += `<p class="mb-0 font-weight-bold">Device: ${location.deviceName}</p>`;
        contentString += `<p class="mb-0">Project: ${location.projectName}</p>`;
        if (location.network.station) {
          contentString += `<p class="mb-0">Gateway: ${location.network.station}</p>`;
        }
        if (location.network.loraSpreadingFactor) {
          contentString += `
              <p class="mt-2 mb-0"> <i class="mr-2 mdi mdi-circle ${this.getIconColors('loraSpreadingFactor', location.network.loraSpreadingFactor)}"></i>Spreading factor: ${location.network.loraSpreadingFactor}</p>
            `;
        }
        if (location.network.snr) {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle ${this.getIconColors('snr', location.network.snr)}"></i>SNR: ${location.network.snr}</p>
              `;
        }
        if (location.network.rssi) {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle ${this.getIconColors('rssi', location.network.rssi)}"></i>RSSI: ${location.network.rssi}</p>
              `;
        }
        if (location.status === 'fault') {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle error--text"></i>Status: Fault</p>
              `;
        }
        if (location.status === 'active') {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle success--text"></i>Status: Active</p>
              `;
        }
        if (location.status === 'inactive') {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle grey--text"></i>Status: Inactive</p>
              `;
        }
      }
      if (location.count > 1) {
        contentString += `</div>`;
      }
      contentString += `
        </div>
      </div>
      `;
      contentString += `
        <button class="mt-4 primary v-btn v-btn--block my-2 text-none v-btn--is-elevated" style="height: 40px" id="goToComposer">
          <span class="v-btn__content">Go to site details <i class="mdi mdi-launch"></i></span>
        </button>
        <button class="mt-2 primary v-btn v-btn--block text-none v-btn--is-elevated" style="height: 40px" id="goToDevice">
          <span class="v-btn__content">Go to device details <i class="mdi mdi-launch"></i></span>
        </button>
      `;
      if (location.count > 1) {
        contentString += `
          </div>
          <div class="d-flex justify-space-between align-center mt-2">
            <button type="button" id="prev-${location.networkId}" class="d-flex align-center">
            <i class="mdi mdi-chevron-left arrow-icon"></i>
            </button>
            <span class="text-body-2">${location.count} devices</span>
            <button type="button" id="next-${location.networkId}">
              <i class="mdi mdi-chevron-right arrow-icon"></i>
            </button>
          </div>
        </div>
      `;
      }
      if (location.hasFaults) {
        contentString +=
            '</div>' +
            '</div>';
      }

      marker.addListener('click', () => {
        const thisMarker: any = marker;
        this.map.panTo(thisMarker.getPosition());
        const parser = new DOMParser();
        const parsed = (parser.parseFromString(contentString, 'text/html')).body;
        const div = document.createElement('div');
        div.innerHTML = parsed.innerHTML;
        this.infoWindow[location.networkId] = div;

        this.newDevicePopup[thisMarker.id] = new DevicePopup(new google.maps.LatLng(thisMarker.position.lat(), thisMarker.position.lng()), this.infoWindow[location.networkId], location.networkId, thisMarker, location);
        const prevBtn = div.querySelector(`#prev-${location.networkId}`);
        const nextBtn = div.querySelector(`#next-${location.networkId}`);

        if (prevBtn && nextBtn) {
          prevBtn.addEventListener('step', (e: any) => {
            this.plusSlides({
              detail: {
                value: -1,
                networkId: location.networkId,
                marker,
              },
            });
          });
          nextBtn.addEventListener('step', (e: any) => {
            this.plusSlides({
              detail: {
                value: 1,
                networkId: location.networkId,
                marker,
              },
            });
          });
        }
        this.newDevicePopup[thisMarker.id].setMap(null);
        const popup: any = document.getElementById(`${thisMarker.id}`);
        if (popup) {
          popup.remove();
        }

        for (const otherMarker in this.deviceMarkers) {
          if (otherMarker !== thisMarker.id) {
            if (this.newDevicePopup[otherMarker]) {
              this.newDevicePopup[otherMarker].setMap(null);
              delete this.newDevicePopup[otherMarker];
            }
          }
        }
        this.newDevicePopup[thisMarker.id].setMap(map);
        marker.setIcon(location &&  location.status === 'fault' ? this.pinSymbol(this.getColor('fault')) : location.status === 'inactive' ? this.pinSymbol(this.getColor('inactive')) : this.pinSymbol(this.getColor('active', location.network.loraSpreadingFactor)));
      });

      window.addEventListener('goToDevice', self.getDeviceInfo);
      window.addEventListener('goToComposer', self.goToComposer);

      window.addEventListener(`closePopup-${location.networkId}`, () => {
        if (this.newDevicePopup[location.networkId]) {
          this.newDevicePopup[location.networkId].setMap(null);
          delete this.newDevicePopup[location.networkId];
        }
      });
    });
  }

  private generateGatewayMarkers(map: google.maps.Map, locations: any) {
    const self = this;
    locations.forEach((location: {[key: string]: any}) => {
      if (!location || !(location.lat && location.lng)) {
        return;
      }
      const marker = new google.maps.Marker({
        map,
        icon: location.status === 'fault' ? this.gatewaySymbol('fault').icon : location.status === 'unknown' ? this.gatewaySymbol('unknown').icon : this.gatewaySymbol('active').icon,
        title: location.name ? location.name : location.locationName,
        id: location.gatewayEui,
        projectId: location.projectId,
        position: {
          lat: Number(location.lat),
          lng: Number(location.lng),
        },
        location,
      } as any);
      this.gatewayMarkers[(marker as any).id] = marker;

      let contentString =
          `<div id="${location.gatewayEui}" class="text-body-2">`;
      contentString +=
          `<div class="row no-gutters d-flex justify-space-between flex-nowrap">
              <div id="col col-auto bodyContent">`;

      if (location.count > 1) {
        contentString += `
          <div class="slideshow-container">
        `;
        this.gatewayLocations.forEach((loc, index) => {
          if (loc.lat === location.lat && loc.lng === location.lng) {
            this.slide[loc.gatewayEui] = index;
            contentString += `<div class="slide-gateway" id="slide_gateway+${loc.gatewayEui}">
                              <p class="font-weight-bold mb-0">Gateway EUI: ${loc.gatewayEui}</p>
                              <p class="font-weight-bold mb-0">Gateway name: ${loc.gatewayName}</p>`;
            contentString += `<p class="mb-0">Project: ${loc.projectName}</p>`;
            if (loc.status === 'fault') {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle error--text"></i>Status: Offline</p>
              `;
            }
            if (loc.status === 'unknown') {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle warning--text"></i>Status: Unknown</p>
              `;
            }
            if (loc.status === 'active') {
              contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle success--text"></i>Status: Active</p>
              `;
            }
            contentString += `</div>`;
          }
        });
      } else {
        contentString += `<p class="font-weight-bold mb-0">Gateway EUI: ${location.gatewayEui}</p>
                            <p class="mb-0 font-weight-bold">Gateway name: ${location.gatewayName}</p>`;
        contentString += `<p class="mb-0">Project: ${location.projectName}</p>`;
        if (location.status === 'fault') {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle error--text"></i>Status: Offline</p>
              `;
        }
        if (location.status === 'unknown') {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle warning--text"></i>Status: Unknown</p>
              `;
        }
        if (location.status === 'active') {
          contentString += `
                <p class="mb-0"> <i class="mr-2 mdi mdi-circle success--text"></i>Status: Active</p>
              `;
        }
      }
      if (location.count > 1) {
        contentString += `</div>`;
      }
      contentString += `
        </div>
      </div>
      `;
      contentString += `
        <button class="mt-4 primary v-btn v-btn--block my-2 text-none v-btn--is-elevated" style="height: 40px" id="goToComposer">
          <span class="v-btn__content">Go to site details <i class="mdi mdi-launch"></i></span>
        </button>
        <button class="mt-2 primary v-btn v-btn--block text-none v-btn--is-elevated" style="height: 40px" id="goToGateway">
          <span class="v-btn__content">Go to gateway details <i class="mdi mdi-launch"></i></span>
        </button>
      `;
      if (location.count > 1) {
        contentString += `
          </div>
          <div class="d-flex justify-space-between align-center mt-2">
            <button type="button" id="prev-${location.gatewayEui}" class="d-flex align-center">
            <i class="mdi mdi-chevron-left arrow-icon"></i>
            </button>
            <span class="text-body-2">${location.count} gateways</span>
            <button type="button" id="next-${location.gatewayEui}">
              <i class="mdi mdi-chevron-right arrow-icon"></i>
            </button>
          </div>
        </div>
      `;
      }
      if (location.hasFaults) {
        contentString +=
            '</div>' +
            '</div>';
      }

      marker.addListener('click', () => {
        const thisMarker: any = marker;
        this.map.panTo(thisMarker.getPosition());
        const parser = new DOMParser();
        const parsed = (parser.parseFromString(contentString, 'text/html')).body;
        const div = document.createElement('div');
        div.innerHTML = parsed.innerHTML;
        this.infoWindow[location.gatewayEui] = div;

        this.newGatewayPopup[thisMarker.id] = new GatewayPopup(new google.maps.LatLng(thisMarker.position.lat(), thisMarker.position.lng()), this.infoWindow[location.gatewayEui], location.gatewayEui, thisMarker, location);
        const prevBtn = div.querySelector(`#prev-${location.gatewayEui}`);
        const nextBtn = div.querySelector(`#next-${location.gatewayEui}`);

        if (prevBtn && nextBtn) {
          prevBtn.addEventListener('step', (e: any) => {
            this.plusGatewaySlides({
              detail: {
                value: -1,
                gatewayEui: location.gatewayEui,
                marker,
              },
            });
          });
          nextBtn.addEventListener('step', (e: any) => {
            this.plusGatewaySlides({
              detail: {
                value: 1,
                gatewayEui: location.gatewayEui,
                marker,
              },
            });
          });
        }
        this.newGatewayPopup[thisMarker.id].setMap(null);
        const popup: any = document.getElementById(`${thisMarker.id}`);
        if (popup) {
          popup.remove();
        }

        // Check for a bunch of things to hide markers not associated with a gateway
        this.clusters.setMap(null);
        this.hideUnassociatedDeviceMarkers(thisMarker);


        for (const otherMarker in this.gatewayMarkers) {
          if (otherMarker !== thisMarker.id) {
            if (this.newGatewayPopup[otherMarker]) {
              this.newGatewayPopup[otherMarker].setMap(null);
              delete this.newGatewayPopup[otherMarker];
            }
          }
        }
        this.newGatewayPopup[thisMarker.id].setMap(map);
        marker.setIcon(location.status === 'fault' ? this.gatewaySymbol('fault').icon : location.status === 'unknown' ? this.gatewaySymbol('unknown').icon : this.gatewaySymbol('active').icon);
      });

      window.addEventListener('goToGateway', self.getGatewayInfo);
      window.addEventListener('goToComposer', self.goToComposer);

      window.addEventListener(`closePopup-${location.gatewayEui}`, () => {
        if (this.newGatewayPopup[location.gatewayEui]) {
          this.newGatewayPopup[location.gatewayEui].setMap(null);
          delete this.newGatewayPopup[location.gatewayEui];
        }
      });
    });
    map.addListener('click', () => {
      this.clusters.setMap(this.map);
      if (Object.keys((this.newGatewayPopup)).length) {
        for (const marker in this.deviceMarkers) {
          if (this.deviceMarkers[marker]) {
            this.deviceMarkers[marker].setVisible(true);
          }
        }
      }
      for (const m in this.gatewayMarkers) {
        if (this.gatewayMarkers[m] && this.gatewayMarkers[m].id) {
          if (this.newGatewayPopup[this.gatewayMarkers[m].id]) {
            this.newGatewayPopup[this.gatewayMarkers[m].id].setMap(null);
            delete this.newGatewayPopup[this.gatewayMarkers[m].id];
          }
        }
      }
    });
  }

  private hideUnassociatedDeviceMarkers(clickedMarker: any) {
    for (const m in this.deviceMarkers) {
      if (this.deviceMarkers.hasOwnProperty(m)) {

        if (this.deviceMarkers[m].location) {
          // console.log(m + ' has location ')
          if (Object.keys(this.deviceMarkers[m].location.network).length) {
            // console.log(m + ' has network with keys ')
            if ('station' in this.deviceMarkers[m].location.network && this.deviceMarkers[m].location.network.station.toLowerCase().startsWith('eui-')) {
              // console.log(m + ' has network with station and station starts eui- ')
              if (this.deviceMarkers[m].location.network.station.slice(4, this.deviceMarkers[m].location.network.station.length).toLowerCase() === clickedMarker.location.gatewayEui.toLowerCase()) {
                // console.log(m + ' has network station sliced that equals gatewayEUI ')
                continue;
              }
            }
          }
        }
        this.deviceMarkers[m].setVisible(false);
      }
    }
  }

  private async goToComposer(e: any) {
    const data = JSON.parse(decodeURI(e.detail.location));
    if (this.activeOrganisation === data.organisationId) {
      await this.changeProjectAsync({projectId: data.projectId, forceRender: false});
    } else {

      await this.changeOrganisationAsync({
        orgId: data.organisationId,
        forceRender: false,
      });
      await this.changeProjectAsync({projectId: data.projectId, forceRender: false});
    }

    this.$router.push({
      name: 'projectcomposer',
      params: {organisationId: data.organisationId.toString(), id: data.locationId.toString()},
    });

  }

  private async getDeviceInfo(e: any) {
    const data = JSON.parse(decodeURI(e.detail.device));
    if (data.locationName) {
      await this.goToDevicesWithFilter(data.organisationId, 0, data.chipId);
    }
  }

  private async getGatewayInfo(e: any) {
    const data = JSON.parse(decodeURI(e.detail.gateway));
    if (data.locationName) {
      await this.goToGatewaysWithFilter(data.organisationId, 0, data.gatewayEui);
    }
  }

  private async goToDevicesWithFilter(organisationId: string, projectId: number, chipId: number) {
    if (this.activeOrganisation === organisationId) {
      await this.changeProjectAsync({projectId, forceRender: false});
    } else {

      await this.changeOrganisationAsync({
        orgId: organisationId,
        forceRender: false,
      });
      await this.changeProjectAsync({projectId, forceRender: false});
    }

    // const key = siteId.toString();
    const filters: any = {};
    filters.chips = [];
    filters.chips.push(chipId);

    this.$router.push({name: 'devices', params: { organisationId: organisationId.toString(), filters: JSON.stringify(filters) }});
  }

  private async goToGatewaysWithFilter(organisationId: string, projectId: number, gatewayEui: string) {
    if (this.activeOrganisation === organisationId) {
      await this.changeProjectAsync({projectId, forceRender: false});
    } else {

      await this.changeOrganisationAsync({
        orgId: organisationId,
        forceRender: false,
      });
      await this.changeProjectAsync({projectId, forceRender: false});
    }

    // const key = siteId.toString();
    const filters: string = gatewayEui;

    this.$router.push({name: 'gateways', params: { organisationId: organisationId.toString(), searchNames: JSON.stringify(filters) }});
  }

  private getColor(status?: string, spreadingFactor?: number) {
    const colors = ['#c9e52f', '#a6d75b', '#76c68f', '#48b5c4', '#22a7f0', '#1984c5'];
    const valueFloor = 7;
    const valueRange = 12 - valueFloor;
    const maxColorIdx = colors.length - 1;
    if (spreadingFactor) {
      const normalizedValue = (spreadingFactor - valueFloor) / valueRange;
      const colorIdx = Math.round(normalizedValue * maxColorIdx);
      return colors[colorIdx];
    }
    if (status && status === 'fault') {
      return '#d10000';
    } else if (status && status === 'inactive') {
      return '#9e9e9e';
    }
    return '#4CAF50';
  }

  private pinSymbol(color?: string) {
    return {
      path: 'M12,2C8.1,2,5,5.1,5,9c0,5.3,7,13,7,13s7-7.7,7-13C19,5.1,15.9,2,12,2z',
      fillColor: color ? color : '#016EA1',
      fillOpacity: 1,
      strokeWeight: 1.5,
      strokeColor: '#ffffff',
      scale: 2,
      anchor: new google.maps.Point(12, 18),
      labelOrigin: new google.maps.Point(12, 0),
    };
  }


  private gatewaySymbol(status: string = 'active') {
    const icons: Record<string, { icon: string; scaledSize: google.maps.Size }> = {
      active: {
        icon: require('@/assets/icons/daizy/gateway_active.png'),
        scaledSize: new google.maps.Size(50, 50),
      },
      unknown: {
        icon: require('@/assets/icons/daizy/gateway_unknown.png'),
        scaledSize: new google.maps.Size(50, 50),
      },
      fault: {
        icon: require('@/assets/icons/daizy/gateway_fault.png'),
        scaledSize: new google.maps.Size(50, 50),
      },
    };

    return icons[status];
  }

  private getIconColors(metric: string, value: number) {
    switch (metric) {
      case 'loraSpreadingFactor':
        switch (value) {
          case 7:
          case 8: return 'success--text';
          case 9:
          case 10: return 'warning--text';
          case 11:
          case 12: return 'error--text';
        }
        break;
      case 'snr':
        if (value > -7) {
          return 'success--text';
        } else if (value <= -7 && value > -15) {
          return 'warning--text';
        } else {
          return 'error--text';
        }
      case 'rssi':
        if (value > -115) {
          return 'success--text';
        } else if (value <= -115 && value > -126) {
          return 'warning--text';
        } else {
          return 'error--text';
        }
    }
  }

  private plusSlides(e: any) {
    if (this.newDevicePopup[e.detail.networkId] && this.slide[e.detail.networkId]) {
      this.showSlides(this.slide[e.detail.networkId] += e.detail.value, e.detail.value, e.detail.networkId, e.detail.marker);
    }
  }

  private showSlides(n: number, i: number, networkId: string, marker: any) {
    const slides = document.querySelectorAll('.slide');
    if (slides && slides.length) {
      if (n > slides.length) {
        this.slide[networkId] = 1;
      }
      if (n < 1) {
        this.slide[networkId] = slides.length;
      }
      (slides as any).forEach((s: HTMLElement) => (s as HTMLElement).style.display = 'none');

      if (i > 0) {
        slides[this.slide[networkId] - 1].classList.add('slide-out-anim');
        setTimeout(() => {
          slides[this.slide[networkId] - 1].classList.remove('slide-out-anim');
        }, 500);
      } else {
        slides[this.slide[networkId] - 1].classList.add('slide-in-anim');
        setTimeout(() => {
          slides[this.slide[networkId] - 1].classList.remove('slide-in-anim');
        }, 500);
      }

      if (slides[this.slide[networkId] - 1]) {
        (slides[this.slide[networkId] - 1] as HTMLElement).style.display = 'block';
        const id = slides[this.slide[networkId] - 1].getAttribute('id');
        if (id) {
          const currSlide = id.split('+')[1];
          const loc = this.deviceLocations.find((l) => l.networkId === currSlide);
          if (loc) {
            marker.setIcon(loc.status === 'fault' ? this.pinSymbol(this.getColor('fault')) : loc.status === 'inactive' ? this.pinSymbol(this.getColor('inactive')) : this.pinSymbol(this.getColor('active', loc.network.loraSpreadingFactor)));
          }
        }
      }
    }
  }

  private plusGatewaySlides(e: any) {
    if (this.newGatewayPopup[e.detail.gatewayEui] && this.slide[e.detail.gatewayEui]) {
      this.showGatewaySlides(this.slide[e.detail.gatewayEui] += e.detail.value, e.detail.value, e.detail.gatewayEui, e.detail.marker);
    }
  }

  private showGatewaySlides(n: number, i: number, gatewayEui: string, marker: any) {
    const slides = document.querySelectorAll('.slide-gateway');

    if (slides && slides.length) {
      if (n > slides.length) {
        this.slide[gatewayEui] = 1;
      }
      if (n < 1) {
        this.slide[gatewayEui] = slides.length;
      }
      (slides as any).forEach((s: HTMLElement) => (s as HTMLElement).style.display = 'none');
      if (i > 0) {
        slides[this.slide[gatewayEui] - 1].classList.add('slide-out-anim');
        setTimeout(() => {
          slides[this.slide[gatewayEui] - 1].classList.remove('slide-out-anim');
        }, 500);
      } else {
        slides[this.slide[gatewayEui] - 1].classList.add('slide-in-anim');
        setTimeout(() => {
          slides[this.slide[gatewayEui] - 1].classList.remove('slide-in-anim');
        }, 500);
      }

      if (slides[this.slide[gatewayEui] - 1]) {
        (slides[this.slide[gatewayEui] - 1] as HTMLElement).style.display = 'block';

        const id = slides[this.slide[gatewayEui] - 1].getAttribute('id');
        if (id) {
          const currSlide = id.split('+')[1];
          const loc = this.gatewayLocations.find((l) => l.gatewayEui === currSlide);
          for (const m in this.deviceMarkers) {
            if (this.deviceMarkers[m]) {
              this.deviceMarkers[m].setVisible(true);
            }
          }
          if (loc) {
            this.hideUnassociatedDeviceMarkers(this.gatewayMarkers[loc.gatewayEui]);
            marker.setIcon(loc.status === 'fault' ? this.gatewaySymbol('fault').icon : loc.status === 'unknown' ? this.gatewaySymbol('unknown').icon : this.gatewaySymbol('active').icon);
          }
        }
      }
    }
  }

  @Watch('orgId')
  private async filterByOrganisation(orgId: number, oldOrgId?: number) {
    if (!orgId) {
      return;
    }
    if (oldOrgId) {
      await this.loadDeviceLocations();
      await this.loadGatewayLocations();
      await this.setMapOptions();
    }
    this.orgId = orgId;
    Vue.set(this, 'deviceLocations', this.deviceLocations.filter((d: any) => d.organisationId === orgId));
    Vue.set(this, 'gatewayLocations', this.gatewayLocations.filter((g: any) => g.organisationId === orgId));
    await this.setMapOptions();
    this.$emit('mapLoaded');

    for (const m in this.deviceMarkers) {
      if (this.deviceMarkers[m] && this.deviceMarkers[m].id) {
        if (this.newDevicePopup[this.deviceMarkers[m].id]) {
          this.newDevicePopup[this.deviceMarkers[m].id].setMap(null);
          delete this.newDevicePopup[this.deviceMarkers[m].id];
        }
      }
    }
  }

  @Watch('projId')
  private async filterByProject(projectId: number, oldProjectId?: number) {
    if (oldProjectId) {
      await this.loadDeviceLocations();
      await this.loadGatewayLocations();
      await this.setMapOptions();
    }
    this.projId = projectId;
    if (this.orgId && !projectId) {
      await this.loadDeviceLocations();
      if (this.hasTTISettings) {
        await this.loadGatewayLocations();
      }
      await this.filterByOrganisation(this.orgId);
      return;
    }
    if (!projectId) {
      return;
    }
    Vue.set(this, 'deviceLocations', this.deviceLocations.filter((d: any) => d.projectId === projectId));
    Vue.set(this, 'gatewayLocations', this.gatewayLocations.filter((d: any) => d.projectId === projectId));
    await this.setMapOptions();
    this.$emit('mapLoaded');
  }

}

class DevicePopup extends google.maps.OverlayView {
  public position;
  public networkId;
  public containerDiv;
  public marker;
  public location;
  constructor(position: google.maps.LatLng, content: HTMLElement, networkId: string, marker: any, location: any) {
    super();
    this.position = position;
    this.networkId = networkId;
    this.marker = marker;
    this.location = location;
    content.classList.add('popup-bubble');

    // This zero-height div is positioned at the bottom of the bubble.
    const bubbleAnchor = document.createElement('div');

    bubbleAnchor.classList.add('popup-bubble-anchor');
    bubbleAnchor.appendChild(content);
    // This zero-height div is positioned at the bottom of the tip.
    this.containerDiv = document.createElement('div');
    this.containerDiv.classList.add('popup-container');
    this.containerDiv.appendChild(bubbleAnchor);
    this.containerDiv.setAttribute('id', networkId);

    DevicePopup.preventMapHitsAndGesturesFrom(this.containerDiv);
  }
  /** Called when the popup is added to the map. */
  public onAdd() {
    this.getPanes().floatPane.appendChild(this.containerDiv);
    const prevBtn = document.getElementById(`prev-${this.networkId}`);
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevBtn.dispatchEvent(new CustomEvent('step', {detail: {value: -1, networkId: this.networkId, marker: this.marker }}));
      });
    }
    const nextBtn = document.getElementById(`next-${this.networkId}`);
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextBtn.dispatchEvent(new CustomEvent('step', {detail: {value: 1, networkId: this.networkId, marker: this.marker }}));
      });
    }

    const closeButton = document.getElementById('closeButton');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent(`closePopup-${this.networkId}`));
      });
    }

    const goToDeviceButton = document.getElementById('goToDevice');
    if (goToDeviceButton) {
      goToDeviceButton.addEventListener('click', async () => {
        window.dispatchEvent(new CustomEvent('goToDevice', { detail: {device: encodeURI(JSON.stringify(this.location))}}));
      });
    }

    const goToComposerButton = document.getElementById('goToComposer');
    if (goToComposerButton) {
      goToComposerButton.addEventListener('click', async () => {
        window.dispatchEvent(new CustomEvent('goToComposer', { detail: {location: encodeURI(JSON.stringify(this.location))}}));
      });
    }
  }
  /** Called when the popup is removed from the map. */
  public onRemove() {
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv);

      const prevBtn = document.getElementById(`prev-${this.networkId}`);
      if (prevBtn) {
        prevBtn.removeEventListener('click', () => {
          prevBtn.dispatchEvent(new CustomEvent('step', {detail: {value: -1, networkId: this.networkId, marker: this.marker }}));
        });
      }
      const nextBtn = document.getElementById(`next-${this.networkId}`);
      if (nextBtn) {
        nextBtn.removeEventListener('click', () => {
          nextBtn.dispatchEvent(new CustomEvent('step', {detail: {value: 1, networkId: this.networkId, marker: this.marker }}));
        });
      }
    }
  }
  /** Called each frame when the popup needs to draw itself. */
  public draw() {
    const divPosition = this.getProjection().fromLatLngToDivPixel(
        this.position,
    );
    // Hide the popup when it is far out of view.
    const display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? 'block'
            : 'none';

    if (display === 'block') {
      this.containerDiv.style.left = divPosition.x + 'px';
      this.containerDiv.style.top = divPosition.y + 'px';
    }

    if (this.containerDiv.style.display !== display) {
      this.containerDiv.style.display = display;
    }
  }

}
class GatewayPopup extends google.maps.OverlayView {
  public position;
  public gatewayEui;
  public gatewayContainerDiv;
  public marker;
  public location;

  constructor(position: google.maps.LatLng, content: HTMLElement, gatewayEui: string, marker: any, location: any) {
    super();
    this.position = position;
    this.gatewayEui = gatewayEui;
    this.marker = marker;
    this.location = location;
    content.classList.add('popup-bubble');

    // This zero-height div is positioned at the bottom of the bubble.
    const bubbleAnchor = document.createElement('div');

    bubbleAnchor.classList.add('popup-bubble-anchor');
    bubbleAnchor.appendChild(content);
    // This zero-height div is positioned at the bottom of the tip.
    this.gatewayContainerDiv = document.createElement('div');
    this.gatewayContainerDiv.classList.add('popup-container');
    this.gatewayContainerDiv.appendChild(bubbleAnchor);
    this.gatewayContainerDiv.setAttribute('id', gatewayEui);

    DevicePopup.preventMapHitsAndGesturesFrom(this.gatewayContainerDiv);
  }

  /** Called when the popup is added to the map. */
  public onAdd() {
    this.getPanes().floatPane.appendChild(this.gatewayContainerDiv);
    const prevBtn = document.getElementById(`prev-${this.gatewayEui}`);
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevBtn.dispatchEvent(new CustomEvent('step', {detail: {value: -1, gatewayEui: this.gatewayEui, marker: this.marker}}));
      });
    }
    const nextBtn = document.getElementById(`next-${this.gatewayEui}`);
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextBtn.dispatchEvent(new CustomEvent('step', {detail: {value: 1, gatewayEui: this.gatewayEui, marker: this.marker}}));
      });
    }

    const closeButton = document.getElementById('closeButton');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent(`closePopup-${this.gatewayEui}`));
      });
    }

    const goToGatewayButton = document.getElementById('goToGateway');
    if (goToGatewayButton) {
      goToGatewayButton.addEventListener('click', async () => {
        window.dispatchEvent(new CustomEvent('goToGateway', {detail: {gateway: encodeURI(JSON.stringify(this.location))}}));
      });
    }

    const goToComposerButton = document.getElementById('goToComposer');
    if (goToComposerButton) {
      goToComposerButton.addEventListener('click', async () => {
        window.dispatchEvent(new CustomEvent('goToComposer', {detail: {location: encodeURI(JSON.stringify(this.location))}}));
      });
    }
  }

  /** Called when the popup is removed from the map. */
  public onRemove() {
    if (this.gatewayContainerDiv.parentElement) {
      this.gatewayContainerDiv.parentElement.removeChild(this.gatewayContainerDiv);

      const prevBtn = document.getElementById(`prev-${this.gatewayEui}`);
      if (prevBtn) {
        prevBtn.removeEventListener('click', () => {
          prevBtn.dispatchEvent(new CustomEvent('step', {detail: {value: -1, gatewayEui: this.gatewayEui, marker: this.marker}}));
        });
      }
      const nextBtn = document.getElementById(`next-${this.gatewayEui}`);
      if (nextBtn) {
        nextBtn.removeEventListener('click', () => {
          nextBtn.dispatchEvent(new CustomEvent('step', {detail: {value: 1, gatewayEui: this.gatewayEui, marker: this.marker}}));
        });
      }
    }
  }

  /** Called each frame when the popup needs to draw itself. */
  public draw() {
    const divPosition = this.getProjection().fromLatLngToDivPixel(
        this.position,
    );
    // Hide the popup when it is far out of view.
    const display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? 'block'
            : 'none';

    if (display === 'block') {
      this.gatewayContainerDiv.style.left = divPosition.x + 'px';
      this.gatewayContainerDiv.style.top = divPosition.y + 'px';
    }

    if (this.gatewayContainerDiv.style.display !== display) {
      this.gatewayContainerDiv.style.display = display;
    }
  }
}
